import consumer from './consumer'

const subscribeToSocialMonitors = (businessId, callbacks) => consumer.subscriptions.create(
  { channel: 'SocialMonitorChannel', business_id: businessId },
  {
    connected: () => callbacks.onConnect?.(),
    disconnected: () => callbacks.onDisconnect?.(),
    received: (data) => callbacks.onMessage?.(data)
  }
)

export default subscribeToSocialMonitors
export { subscribeToSocialMonitors }
